import React, { useState, useEffect } from 'react';

import TabContentTitle from '../TabContentTitle';
import ViewReportTh from '../../ViewReportTh';

import classes from './styles.module.scss';
import { renderRows } from './helpers';

const ths = [
  {
    title: 'Name',
    field: 'name',
  },
  {
    title: 'Videos in Folder',
    field: 'meetingCount',
  },
  {
    title: 'Upload Date',
    field: 'createdAt',
  },
  {
    title: 'Viewer Status',
    field: 'completionStatus',
  },
  {
    title: 'Viewer Completion %',
    field: 'completionRate',
  },
  /* {
    title: '',
    field: 'actions',
  }, */
];

export default function VideosReport({
  report,
  sortField,
  sortOrder,
  setSortField,
  setSortOrder,
  showSummaryReportModal,
  isExport,
}) {
  const [expandedFolderIds, setExpandedFolderIds] = useState([]);

  // Root folder should be expanded by default
  useEffect(() => {
    if (report) {
      setExpandedFolderIds((prevState) => {
        if (prevState.length) {
          return prevState;
        }
        return [report[0]?.[0]?.id];
      });
    }
  }, [report, setExpandedFolderIds]);

  let curretnThs = ths;

  if (isExport) {
    curretnThs = ths.slice(0, ths.length - 1);
  }

  return (
    <div className={classes.VideosReport}>
      <TabContentTitle title="Published Video Report Summary" isExport />
      <table id="videos-report-table">
        <thead>
          <tr>
            {curretnThs.map((th) => (
              <ViewReportTh
                key={th.field}
                title={th.title}
                field={th.field}
                sortField={sortField}
                sortOrder={sortOrder}
                setSortField={setSortField}
                setSortOrder={setSortOrder}
                isExport={isExport}
              />
            ))}
          </tr>
        </thead>
        <tbody>
          {renderRows({
            tree: report,
            nestLevel: 0,
            showSummaryReportModal,
            isExport,
            expandedFolderIds,
            setExpandedFolderIds,
          })}
        </tbody>
      </table>
    </div>
  );
}
